import React, { Component } from "react";
import { Amount, Icon, Switch, Tag, Text } from "@mbank-design/design-system/components";
import Tooltip from "../Tooltip";
import "./index.scss";
import { ShieldTick, Tire, Gear, CreditCard, CarPhoneHandle, Car, Wrench } from "@mbank-design/design-system/icons";
import { SwitchColor } from "@mbank-design/design-system/enums";


export default class AdditionalPackageTile extends Component {
  constructor(props){
    super(props)
    this.iconMap = {
      1: {icon:Wrench, tooltip:undefined},
      2: {icon:CreditCard, tooltip:"<b>Zyskaj 10 groszy brutto rabatu na paliwo z kartą paliwową w mLeasingu!</b> Tankuj i ruszaj w drogę bez zbędnych formalności. Karta paliwowa to wygoda płatności bezgotówkowych i przejrzyste rozliczenia. Zbiorczą refakturę za tankowanie otrzymasz w kolejnym miesiącu."},
      3: {icon:Tire, tooltip:"Już nigdy nie martw się o wymianę opon! Kupimy dla Ciebie ich drugi komplet oraz zorganizujemy wymianę ogumienia dwa razy do roku. Zapasowe opony przechowamy do następnego sezonu."},
      4: {icon:CreditCard, tooltip:"<b>Zyskaj 10 groszy brutto rabatu na paliwo z kartą paliwową w mLeasingu!</b> Tankuj i ruszaj w drogę bez zbędnych formalności. Karta paliwowa to wygoda płatności bezgotówkowych i przejrzyste rozliczenia. Zbiorczą refakturę za tankowanie otrzymasz w kolejnym miesiącu."},
      5: {icon:CarPhoneHandle, tooltip:"Z ochroną assistance dla kierowców i pasażerów, która działa 24 h na dobę, żadne niespodzianki na drodze Ci niestraszne. Pakiet zawiera m.in.: <b>samochód zastępczy bez limitu</b>, holowanie, naprawę w miejscu zdarzenia, pomoc w podróży i pomoc medyczną."},
      6: {icon:ShieldTick, tooltip:"Wieloletnie ubezpieczenie OC, AC, NNW i Autoszyba z gwarancją niezmiennej składki. Opłacasz w wygodnych ratach na podstawie refaktury ze stawką VAT ZW. <b>Bez dodatkowych opłat!</b>"},
      7: {icon:Wrench, tooltip:undefined},
      8: {icon:Wrench, tooltip:"Pakiet Prestige obejmuje <b>wszelkie przeglądy, wymiany części eksploatacyjnych i naprawy samochodu wynikające z jego normalnej eksploatacji</b>, także po okresie gwarancji, w ramach wybranego limitu kilometrów."},
      9: {icon:Wrench, tooltip:"Pakiet Prestige obejmuje <b>wszelkie przeglądy, wymiany części eksploatacyjnych i naprawy samochodu wynikające z jego normalnej eksploatacji</b>, także po okresie gwarancji, w ramach wybranego limitu kilometrów."},
    }
  }
  emitChanges(pkg) {
    if (!this.props.isPreviewOnly) {
      this.props.changePackageStatus(pkg.Name.split(" ").join("_"));
    }
  }

  render() {
    let pkg = this.props.package;
    let state = this.props.packagesState;
    let isChecked = null;
    if (pkg) {
      isChecked = this.props.isPreviewOnly
        ? pkg.isChecked
        : state[pkg.Name.split(" ").join("_")].isChecked;
    }
    let price = this.props.useStateAmount
      ? state[pkg.Name.split(" ").join("_")].Price
      : pkg.Price;
    return (
      <>
        {pkg && (
          <div
            className={`additional-package-tile-container ${pkg.Indent && !this.props.isPreviewOnly ? "indent" : ""}`}
          >
            <div className="display-row">
              {this.props.iconVisible && <Icon iconComponent={this.iconMap[pkg.Value].icon} primaryColor={"endeavourBlueUI"}/>}
              <Text
                as={"p"}
                styledAs={"small"}
                color={this.props.color ? this.props.color : "zeusBlackUI"}
              >
                {pkg.Name}
              </Text>
              {!this.props.tooltipHidden && pkg.HiddenPrice && <Tooltip
                title={pkg.Name}
                icon={pkg.IconName}
                darkMode={this.props.darkMode}
                description={this.iconMap[pkg.Value].tooltip ? this.iconMap[pkg.Value].tooltip : pkg?.EkstraTooltip ? pkg.Tooltip + pkg.EkstraTooltip : pkg.Tooltip}
              />}
            </div>
            <div className="right-wing">
              {!!pkg.Price && !pkg.HiddenPrice && (
                <Text
                  as={"p"}
                  styledAs={"small"}
                >
                  {isChecked && price !== undefined ? (
                    <Amount
                      isFractionPartShown={false}
                      currencyDisplay="symbol"
                      currency="PLN"
                      periodSuffix="month"
                      isFractionPartResized={false}
                      styledAsTextTagName={"p"}
                      value={isChecked ? price : "Ładowanie ..."}
                    />
                  ) : null}
                </Text>
              )}
              {((pkg.Disabled|| pkg.Enabled) && pkg.HiddenPrice && (pkg.SetSelfAsTrue || pkg.isChecked) || (pkg.HiddenPrice && this.props.isPreviewOnly)) ?
              <Tag backgroundColor="funGreenUI">w racie</Tag>
              : !this.props.isPreviewOnly && (
                <Switch
                  checked={isChecked}
                  disabled={this.props.disabled || pkg.Price === null || pkg.Disabled}
                  color={SwitchColor.BLUE}
                  onChange={() => this.emitChanges(pkg)}
                ></Switch>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}
